import remote from "../../../../services/remote";
import {getDentistDetailsFailure, getDentistDetailsSuccess} from "./actions";
import {GET_DENTIST_DETAILS_REQUEST} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* getDetails(action) {
    try {
        const response = yield call(remote, {
            route: `/admin/dentists/get-dentist-details/${action.data.dentistId}`,
            method: 'get'
        });
        if (response.success) {
            yield put(getDentistDetailsSuccess(response.data));
        } else {
            yield put(getDentistDetailsFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchAdminDentistDetails() {
    yield takeLatest(GET_DENTIST_DETAILS_REQUEST , getDetails);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DentistDetails/saga.js